import React from "react";

function LogoBlue(props) {
  return (
    <img
      alt="Logo"
      src={process.env.PUBLIC_URL + "/static/leterago-logo-new.png"}
      {...props}
    />
  );
}

export default LogoBlue;
